import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import moment from 'moment';
import { fetchWalletTransactions } from '../api/Pageapi';
import HeadingBanner from '../Components/HeadingBanner';
import Dashboard from '../Components/Dashboard';
import { FaHistory, FaCopy } from 'react-icons/fa';
import toast from 'react-hot-toast';

const WalletHistory = ({ settings }) => {
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });
    const [rowCount, setRowCount] = useState(0);

    const getTransactions = (page) => {
        setLoading(true);
        fetchWalletTransactions(page + 1)
            .then((res) => {
                if (res.status) {
                    setTransactions(res.data || []);
                    setRowCount(res.pagination?.total || 0);
                }
                setLoading(false);
            })
            .catch((err) => {
                console.error(err);
                setLoading(false);
            });
    };

    useEffect(() => {
        getTransactions(paginationModel.page);
    }, [paginationModel.page]);

    const columns = [
        {
    field: 'transaction_id',
    headerName: 'Transaction ID',
    flex: 1.5,
    minWidth: 200,
    renderCell: (params) => {
        const fullId = params.value;
        const shortId = fullId?.length > 12 ? fullId.substring(0, 12) + '...' : fullId;
        
        return (
            <div className="d-flex align-items-center gap-2">
                <span 
                    style={{ fontSize: '13px' }}
                    title={fullId}
                >
                    {shortId}
                </span>
                <button
                    onClick={() => {
                        navigator.clipboard.writeText(fullId);
                        toast.success("Transaction ID copied!");
                    }}
                    style={{
                        border: 'none',
                        background: 'transparent',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        padding: '4px',
                        color: '#650020',
                    }}
                    title="Copy ID"
                >
                    <FaCopy size={14}  />
                </button>
            </div>
        );
    }
},,
        {
            field: 'created_at',
            headerName: 'Date',
            flex: 1,
            minWidth: 120,
            valueGetter: (value, row) => moment(row.created_at).format('DD-MM-YYYY HH-MM'),
        },
        {
            field: 'transaction_type',
            headerName: 'Type',
            flex: 1,
            minWidth: 150,
            renderCell: (params) => (
                <span style={{ textTransform: 'capitalize' }}>
                    {params.value.replace(/_/g, ' ')}
                </span>
            )
        },
        {
            field: 'amount',
            headerName: 'Amount',
            flex: 1,
            minWidth: 130,
            renderCell: (params) => {
                const credit = parseFloat(params.row.credit);
                const debit = parseFloat(params.row.debit);
                if (credit > 0) {
                    return <span className="text-success" style={{ fontWeight: '600' }}>+ ₹{credit.toFixed(2)}</span>;
                } else if (debit > 0) {
                    return <span className="text-danger" style={{ fontWeight: '600' }}>- ₹{debit.toFixed(2)}</span>;
                }
                return <span>₹0.00</span>;
            }
        },
        {
            field: 'balance',
            headerName: 'Balance',
            flex: 1,
            minWidth: 130,
            renderCell: (params) => (
                <span style={{ fontWeight: '600' }}>₹{parseFloat(params.value).toFixed(2)}</span>
            )
        },
    ];

    return (
        <>
            <HeadingBanner title="Wallet History" />
            <section className="my-profile section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3">
                            <Dashboard setting_data={settings} />
                        </div>
                        <div className="col-lg-9">
                            <div className="myprofile-content">
                                <div className="bd-heads pb-3 d-flex align-items-center gap-2">
                                    <FaHistory size={24} color="#333" />
                                    <h4 style={{ margin: 0, fontWeight: '700', fontSize: '24px' }}>Transaction History</h4>
                                </div>
                                <div className="bd-form p-0" style={{ 
                                    height: 600, 
                                    width: '100%', 
                                    backgroundColor: 'white',
                                    border: '1px solid #e0e0e0',
                                    borderRadius: '15px',
                                    overflow: 'hidden'
                                }}>
                                    <DataGrid
                                        rows={transactions}
                                        columns={columns}
                                        rowCount={rowCount}
                                        loading={loading}
                                        pageSizeOptions={[10]}
                                        paginationModel={paginationModel}
                                        paginationMode="server"
                                        onPaginationModelChange={setPaginationModel}
                                        disableRowSelectionOnClick
                                        sx={{
                                            border: 'none',
                                            "& .MuiDataGrid-columnHeaders": {
                                                backgroundColor: "#fff",
                                                borderBottom: "1px solid #e0e0e0",
                                            },
                                            "& .MuiDataGrid-columnHeaderTitle": {
                                                fontWeight: "700",
                                                color: "#555",
                                            },
                                            "& .MuiDataGrid-virtualScroller": {
                                                "&::after": {
                                                    content: '""',
                                                    position: "absolute",
                                                    top: "50%",
                                                    left: "50%",
                                                    transform: "translate(-50%, -51%)",
                                                    width: "300px",
                                                    height: "300px",
                                                    backgroundImage: 'url("/assets/iocns/GH Logo.png")',
                                                    backgroundSize: "contain",
                                                    backgroundRepeat: "no-repeat",
                                                    opacity: 0.1,
                                                    zIndex: -1,
                                                    pointerEvents: "none",
                                                },
                                            },
                                            "& .MuiDataGrid-row": {
                                                backgroundColor: "transparent !important",
                                                borderBottom: "1px solid #f0f0f0",
                                                "&:nth-of-type(odd)": {
                                                    backgroundColor: "rgba(0, 0, 0, 0.01) !important",
                                                },
                                            },
                                            "& .MuiDataGrid-footerContainer": {
                                                borderTop: "1px solid #e0e0e0",
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default WalletHistory;
